import { EventEmitter } from "events";
import "whatwg-fetch";
import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import env from "../common/env";
// import qs from "qs";
import { encrypt, decrypt } from "./pcrypto";
import { currentEnv } from "@/config";

/** 是否为开发环境 */
const isDevelopment = currentEnv === "test";
/** 是否为线上环境 */
const isOnline = currentEnv === "prd";

const CLIENT_BASE_URL = `/cctip/v1`;
const SERVER_BASE_URL = `https://${env.wwwDomain}/cctip/v1`;
const ADMIN_BASE_URL = `/cashier/cashier-api`;

const ADMIN_BASE_URL_TOKEN_V2 = `${
  isDevelopment
    ? ""
    : isOnline
    ? "https://ccpayment.com"
    : "https://admin-test-v2.ccpayment.com"
}`;

// 本地开发时只保留 /ccpayment/v1
const ADMIN_BASE_URLV2 = `${
  isDevelopment
    ? ""
    : isOnline
    ? "https://ccpayment.com"
    : "https://admin-test-v2.ccpayment.com"
}/ccpayment/v1`;

const ADMIN_BASE_URLV3 = `${
  isDevelopment
    ? ""
    : isOnline
    ? "https://ccpayment.com"
    : "https://admin-test-v2.ccpayment.com"
}/account/v1`;

const ADMIN_BASE_URLV4 = `${
  isDevelopment
    ? ""
    : isOnline
    ? "https://ccpayment.com"
    : "https://admin-test-v2.ccpayment.com"
}/payment/v1`;

const ADMIN_BASE_URLV5 = `${
  isDevelopment
    ? ""
    : isOnline
    ? "https://ccpayment.com"
    : "https://admin-test-v2.ccpayment.com"
}/ccpayment/v2`;

const ADMIN_BASE_URLV6 = `${
  isDevelopment
    ? ""
    : isOnline
    ? "https://ccpayment.com"
    : "https://admin-test-v2.ccpayment.com"
}/account/v1`;

// const ADMIN_BASE_URLV2 = `/ccpayment/v1`;

// const ADMIN_BASE_URLV2 = `/ccpayment/v1`;
const TIME_OUT = 30 * 1000;

// const generateReqKey = (config: AxiosRequestConfig) => {
//   const { method, url, params, data } = config;
//   return [method, url, qs.stringify(params), qs.stringify(data)].join("&");
// };

// const pendingRequest = new Map();
// const addPendingRequest = (config: AxiosRequestConfig) => {
//   const requestKey = generateReqKey(config);
//   config.cancelToken =
//     config.cancelToken ||
//     new axios.CancelToken((cancel) => {
//       if (!pendingRequest.has(requestKey)) {
//         pendingRequest.set(requestKey, cancel);
//       }
//     });
// };

// const removePendingRequest = (config: AxiosRequestConfig) => {
//   const requestKey = generateReqKey(config);
//   if (pendingRequest.has(requestKey)) {
//     const cancelToken = pendingRequest.get(requestKey);
//     // console.log(cancelToken, requestKey);
//     cancelToken(requestKey);
//     pendingRequest.delete(requestKey);
//   }
// };

class Http extends EventEmitter {
  /** 自定义响应拦截器 */
  resInterceptors: ((packt: Packt) => Packt)[] = [];
  /** 根据返回的包信息生成对应的错误提示内容  */
  getResponseErrorMsg = (packt: Packt) => packt.msg;
  public instance: AxiosInstance;
  constructor(config: AxiosRequestConfig) {
    super();
    this.instance = axios.create(config);

    // 创建全局请求拦截器
    this.instance.interceptors.request.use(
      (config) => {
        return {
          ...config,
          headers: {
            ...config.headers,
          },
        };
      },
      (err) => {
        return err;
      }
    );
    // 创建全局响应拦截器
    this.instance.interceptors.response.use(
      (config) => {
        if (config.status !== 200) {
          throw new Error(`${config.statusText}! ${config.config.url}`);
        }
        return config.data;
      },
      (err) => {
        // console.log(err);
        throw new Error(err);
      }
    );
  }

  /**
   *传入的泛型是约束返回值
   * env 是否需要环境判断
   * @memberof Http
   */

  async request<T>(config: AxiosRequestConfig): Promise<any> {
    const currentTimes = new Date().getTime();

    config.headers = {
      ...config.headers,
      "X-Timestamp": currentTimes.toString(),
    };

    try {
      if (
        (config.method as string).toLowerCase() === "post" &&
        ((this!.instance!.defaults!.baseURL as any).includes("/account/v1") ||
          config.url?.includes("notification")) &&
        typeof config.data === "string" &&
        isOnline
      ) {
        config.transformRequest = [
          function (data, headers) {
            // 手动将数据转换为字符串
            return data;
          },
        ];
        config.data = encrypt(
          config.data ? config.data : JSON.stringify({}),
          currentTimes
        );
      }
    } catch (error) {
      throw new Error("Encryption Failed!");
    }

    return new Promise((resolve, reject) => {
      this.instance
        .request<any, T>(config)
        .then((res) => {
          const result = { currentTimes, res };

          resolve(result);
        })
        .catch((err) => {
          reject({ res: err, currentTimes });
        });
    });
  }
  async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.request<T>({ ...config, method: "GET", url });
  }

  async post<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    let token = localStorage.getItem("Authorization");
    if (token) {
      token = JSON.parse(token);
    }
    return this.request<T>({
      ...config,
      method: "POST",
      url,
      data: JSON.stringify(config?.data),
      headers: {
        "Content-Type": "application/json",
        Authorization: token || "",
        ...config?.headers,
      },
    });
  }

  async fromPost<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.request<T>({
      ...config,
      method: "POST",
      url,
      data: config?.data,
      headers: {
        ...config?.headers,
      },
    });
  }

  async getJson<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.decodeJsonPackt(this.get(url, config));
  }
  async postJson<T = any>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<T> {
    return this.decodeJsonPackt(this.post(url, config));
  }
  async fetchJson<T = any>(
    url: string,
    config: AxiosRequestConfig
  ): Promise<T> {
    return this.decodeJsonPackt(
      this.request({
        ...config,
        url,
      })
    );
  }

  async postForm(url: string, data: FormData) {
    return this.decodeJsonPackt(
      this.request({
        url,
        data,
        method: "POST",
      })
    );
  }

  private async decodeJsonPackt(
    req: Promise<Packt>,
    currentTimes?: number
  ): Promise<any> {
    let packt = await req;

    try {
      // decrypt
      if (packt && typeof (packt as any).res === "string") {
        packt = JSON.parse(
          decrypt((packt as any).res, (packt as any)?.currentTimes)
        );
      } else {
        packt = {
          ...(packt as any)?.res,
        };
      }
    } catch (error) {
      throw new Error("Decryption failed");
    }

    /**没登陆 */
    if (packt.code === 10072) {
    } else if (![1000, 10000, 10072].includes(packt.code)) {
      const msg = this.getResponseErrorMsg(packt);
      packt.msg = msg === packt.code + "" ? packt.msg : msg;
      throw new HttpResponseError(packt.msg, packt.code, packt);
    }
    for (let fn of this.resInterceptors) {
      packt = fn(packt);
    }

    return packt.data;
  }
}

interface Packt {
  code: number;
  data: any;
  msg: string;
}

export class HttpResponseError extends Error {
  constructor(msg: string, public code: number, public response: any) {
    super(msg);
  }
}

export const http = new Http({
  baseURL: CLIENT_BASE_URL,
  timeout: TIME_OUT,
  withCredentials: true,
});

export const http_server = new Http({
  baseURL: SERVER_BASE_URL,
  timeout: TIME_OUT,
  withCredentials: true,
});

export const http_ccpayment = new Http({
  baseURL: ADMIN_BASE_URL,
  timeout: TIME_OUT,
  withCredentials: true,
});

export const http_ccpayment__api_v2 = new Http({
  baseURL: ADMIN_BASE_URL_TOKEN_V2,
  timeout: TIME_OUT,
  withCredentials: true,
});

export const http_ccpayment_v2 = new Http({
  baseURL: ADMIN_BASE_URLV2,
  timeout: TIME_OUT,
  withCredentials: true,
});

export const http_ccpayment_v3 = new Http({
  baseURL: ADMIN_BASE_URLV3,
  timeout: TIME_OUT,
  withCredentials: true,
});

export const httpPayment = new Http({
  baseURL: ADMIN_BASE_URLV4,
  timeout: TIME_OUT,
  withCredentials: true,
});

export const http_ccpayment_v5 = new Http({
  baseURL: ADMIN_BASE_URLV5,
  timeout: TIME_OUT,
  withCredentials: true,
});

export const http_ccpayment_v6 = new Http({
  baseURL: ADMIN_BASE_URLV6,
  timeout: TIME_OUT,
  withCredentials: true,
});
